import axios from "axios";
import apiPath from "../constants/apiPath";

const getStoredToken = () => {
  const directToken = localStorage.getItem("token");
  if (directToken) return directToken;
  try {
    const loginDataRaw = localStorage.getItem("loginData");
    if (!loginDataRaw) return "";
    const loginData = JSON.parse(loginDataRaw);
    return (
      loginData?.token ||
      loginData?.accessToken ||
      loginData?.jwt ||
      loginData?.data?.token ||
      loginData?.data?.accessToken ||
      loginData?.Details?.token ||
      ""
    );
  } catch (_err) {
    return "";
  }
};

const api = axios.create({
  baseURL: apiPath.baseURL,
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getImageUrl = (img) => {
  if (!img) return "";
  if (typeof img !== "string") return "";
  if (img.startsWith("http://") || img.startsWith("https://")) return img;
  return `${apiPath.assetURL}${img}`.replace(/([^:]\/)\/+/g, "$1");
};

export default api;

